import { Badge, Grid, IconButton, Tooltip } from "@mui/material";
import { ICellRendererParams } from "ag-grid-community";

import MuiIcon from "../../../../../../../../../shared/styles/mui/helpers/mui-icon.helper";
import IPivotChildColumn from "../../../../../../../../../shared/contracts/IPivotChildColumn";
import useWizardPivotChildColumnService from "../wizard-pivot-child-columns.service";



/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Jan/05/2025
 */
export default function WizardPivotChildColumnRowActionsRenderer(
    props: ICellRendererParams<IPivotChildColumn>
) {

    const { insertRow, removeRow } = useWizardPivotChildColumnService()

    const handleInsertRowAbove = () => {
        insertRow(props.api, props.node.rowIndex);
    }

    const handleInsertRowBelow = () => {
        insertRow(props.api, props.node.rowIndex === null ? 0 : props.node.rowIndex + 1);
    }

    const handleRemoveRow = () => {
        removeRow(props.api, props.node.data);
    }

    const handleShowSettings = () => {
        //TODO: implement
    }


    return (
        <Grid container direction='row' alignItems='center'
            justifyContent='start' sx={{ mt: 0, }} style={{ border: '0px solid red' }}>

            <Grid item sx={{ pl: .5 }}>
                <Tooltip title='insert new row above' leaveDelay={0}>
                    <IconButton onClick={handleInsertRowAbove} size="small" color="primary">
                        <Badge color="default" overlap="rectangular"
                            badgeContent={MuiIcon.ADD({ sx: { fontSize: '15px', color: (t) => t.palette.info.main } })}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}>
                            {MuiIcon.ABOVE()}
                        </Badge>
                    </IconButton>
                </Tooltip>
            </Grid>

            <Grid item sx={{ pl: .5 }}>
                <Tooltip title='insert new row below' leaveDelay={0}>
                    <IconButton onClick={handleInsertRowBelow} size="small" color="info">
                        <Badge color="default" overlap="rectangular"
                            badgeContent={MuiIcon.ADD({ sx: { fontSize: '15px', color: (t) => t.palette.primary.main } })}
                            anchorOrigin={{ vertical: 'top', horizontal: 'left', }}>
                            {MuiIcon.BELOW()}
                        </Badge>
                    </IconButton>
                </Tooltip>
            </Grid>

            <Grid item sx={{ pl: .5 }}>
                <Tooltip title='settings'>
                    <IconButton onClick={handleShowSettings} size="small" color="default">{MuiIcon.SETTINGS()}</IconButton>
                </Tooltip>
            </Grid>

            <Grid item sx={{ pl: .5 }}>
                <Tooltip title='delete'>
                    <IconButton onClick={handleRemoveRow} size="small" color="error">{MuiIcon.REMOVE()}</IconButton>
                </Tooltip>
            </Grid>

        </Grid>
    );
}